export const vehicleConstants = {
  DELETE_VEHICLE_REQUEST: "DELETE_VEHICLE_REQUEST",
  DELETE_VEHICLE_SUCCESS: "DELETE_VEHICLE_SUCCESS",
  DELETE_VEHICLE_FAILURE: "DELETE_VEHICLE_FAILURE"
}